import React from 'react';
import { Chip } from './ui/display/Chip';
import styled from 'styled-components';

interface Props {
  areaName: string;
  topicName: string;
  onClose?: () => void;
  keywordsLevels: KeywordsLevels;
}

const KeywordChip: React.FC<Props> = ({ areaName, topicName, onClose, keywordsLevels }) => {
  return (
    <StyledChip className="bg-gray-200 text-gray-500 mt-1 mb-2 mobileCtrlKeywordChip" onClose={onClose}>
      <>
        {keywordsLevels == 2 ? (
          <>
            <p className="font-bold mb-1.5">{areaName}</p>
            <p>{topicName}</p>
          </>
        ) : (
          <>
            <p className="font-bold">{topicName}</p>
          </>
        )}
      </>
    </StyledChip>
  );
};

const StyledChip = styled(Chip)`
  padding-top: 6px;
  padding-bottom: 6px;
  height: auto;
  padding-left: 18px;
  padding-right: 18px;
`;

export default KeywordChip;
